import { backendApi } from "@/services/api";
import type { Process } from "@/services/backend/processes/process/process";
import { Filter } from "@/shared/lib/filter/filter";
import { OrdrBy } from "@/shared/lib/ordr/ordrBy";
import { ArtefactKind } from "../../artefacts/kind";
import { Label } from "../state/state";

const processesApi = backendApi.injectEndpoints({
  endpoints: (build) => ({
    putProcess: build.mutation<Process, PutRequest>({
      query: (request) => ({
        url: `/processes`,
        method: "PUT",
        body: request,
      }),
      invalidatesTags: ["Process"],
    }),
    processesList: build.query<List, ListRequest>({
      query: (request) => ({
        url: `/processes`,
        method: "GET",
        params: {
          request: btoa(JSON.stringify(request)),
        },
      }),
      providesTags: ["Process"],
    }),
    getProcess: build.query<Process, GetRequest>({
      query: (request) => ({
        url: `/processes/${request.id}`,
        method: "GET",
        params: request,
      }),
      providesTags: (_result, _e, request) => [
        { type: "Process", id: request.id },
      ],
    }),
  }),
});

export const {
  useProcessesListQuery,
  useGetProcessQuery,
  usePutProcessMutation,
} = processesApi;

export interface PutRequest {
  id: string;
  customerId: string;
  topic: string;
  processNumber: string;
}

export interface GetRequest {
  id: string;
}

export interface ListRequest {
  currentMilestone?: Filter<ArtefactKind>;
  customerId?: Filter<string>;
  orderBy?: OrdrBy<string>[];
  state?: Filter<Label>;
  limit: number;
  offset: number;
}

export interface List {
  count: number;
  items: Process[];
}
